var map = {
	"./1-active.png": "Ldj4",
	"./1.png": "QTg/",
	"./2-active.png": "O84m",
	"./2.png": "wdhx",
	"./3-active.png": "rBrb",
	"./3.png": "asGQ",
	"./4-active.png": "p1G5",
	"./4.png": "fx5/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xApI";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/nav ^\.\/.*\.png$
// module id = xApI
// module chunks = 0